// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoriteDriverDetail_container__1V5Vo","red":"FavoriteDriverDetail_red__2Cmt-","grey":"FavoriteDriverDetail_grey__d4ZeF","black":"FavoriteDriverDetail_black__z1qmN"};